<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :style="style"
    :width="width || dimensions"
    :height="height || dimensions"
  >
    <use :xlink:href="icon"></use>
  </svg>
</template>

<script>
import spriteUrl from '@/assets/images/icon-sprite.svg'
import { DOCUMENT_ICON_IDS } from '@/constants/IconConstants.js'

export default {
  props: {
    use: {
      required: true,
      type: String
    },
    dimensions: {
      default: 30,
      type: [String, Number]
    },
    width: {
      type: [String, Number],
      required: false
    },
    height: {
      type: [String, Number],
      required: false
    }
  },
  computed: {
    // Above-the-fold icons are inlined into the document (IconSetCritical) and
    // resolve locally; everything else points into the external sprite file,
    // which is hashed and cached for a year (VIP-12355). Cross-document <use>
    // references inherit inherited CSS properties — custom properties
    // included — from this element, so themed fills keep working.
    icon() {
      // No id, no request: a bare fragment is a same-document no-op, exactly
      // what the inline sprite produced before (VIP-12355).
      if (!this.use) return '#'
      const local = DOCUMENT_ICON_IDS.has(this.use)
      return `${local ? '' : spriteUrl}#${this.use}`
    },
    style() {
      return `width: ${this.width || this.dimensions}; height: ${this.height || this.dimensions};`
    }
  }
}
</script>
